module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-footer",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modalNuevo"
    },
    on: {
      "click": function($event) {
        return _vm.limpiar()
      }
    }
  }, [_vm._v("Nuevo Registro")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.areas), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(item.cont))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.descripcion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sigla))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nombres) + " " + _vm._s(item.apePaterno) + " " + _vm._s(item.apeMaterno))]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalNuevo"
      },
      on: {
        "click": function($event) {
          return _vm.ver(item)
        }
      }
    }, [_vm._v("O")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'area_detalle' /*, params: { idArea: item.idArea, descripcionArea: item.descripcion }*/
        }
      }
    }, [_c('span', {
      staticClass: "badge bg-yellow",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.enviar(item)
        }
      }
    }, [_vm._v("\n                              V\n                            ")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [_c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error.desError) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalNuevo",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body fs-12"
  }, [_vm._v("\n                      Descripción:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area.descripcion),
      expression: "area.descripcion"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text",
      "id": "descripcion"
    },
    domProps: {
      "value": (_vm.area.descripcion)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.area, "descripcion", $event.target.value)
      }, _vm.handleDescripcionInput]
    }
  }), _c('br'), _vm._v("\n                      Tipo:"), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area.tipo),
      expression: "area.tipo"
    }],
    staticClass: "form-control m-t-10",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.area, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("COMISIÓN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("DESPACHO DE MAGISTRADO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "T"
    }
  }, [_vm._v("TRIBUNAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "X"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('br'), _vm._v("\n                      Sigla:"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.area.sigla),
      expression: "area.sigla"
    }],
    staticClass: "form-control m-t-10",
    attrs: {
      "type": "text",
      "id": "sigla",
      "disabled": _vm.isEditMode
    },
    domProps: {
      "value": (_vm.area.sigla)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.area, "sigla", $event.target.value)
      }, _vm.handleSiglaInput]
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.mensajeLimiteSigla))]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "representante-container"
  }, [_c('span', {
    staticClass: "representante-label"
  }, [_vm._v("Representante:")]), _c('br'), _vm._v(" "), _c('v-select', {
    staticClass: "fuente form-control m-t-10 m-b-10 combobox-personalizado2",
    staticStyle: {
      "padding": "0px",
      "border-style": "hidden"
    },
    attrs: {
      "options": _vm.filteredUsuarios,
      "filterable": true,
      "label": "nombreCompleto",
      "placeholder": "Seleccionar"
    },
    on: {
      "input": _vm.selectPersonal
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function(ref) {
        var search = ref.search;

        return [_vm._v("\n                            Lo siento, no hay usuarios que coincidan con \"" + _vm._s(search) + "\".\n                          ")]
      }
    }]),
    model: {
      value: (_vm.selectedIdPersonal),
      callback: function($$v) {
        _vm.selectedIdPersonal = $$v
      },
      expression: "selectedIdPersonal"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": !_vm.area.descripcion || !_vm.area.sigla || _vm.area.idRepresenta == '0',
      "title": (!_vm.area.descripcion || !_vm.area.sigla || _vm.area.idRepresenta == '0') ? 'Para guardar, complete todos los campos' : ''
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("\n                        Guardar Cambios")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                      Se anulará el área " + _vm._s(_vm.area.descripcion) + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Anular Área")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v("MANTENIMIENTO DE ÁREAS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting_asc",
    attrs: {
      "aria-label": "DESCRIPCIÓN",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("DESCRIPCIÓN")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "URL",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("TIPO")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "SIGLA",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("SIGLA")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "REPRESENTANTE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                          REPRESENTANTE")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "MODIFICAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("MODIFICAR\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "DETALLE",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("DETALLE")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ANULAR")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("ANULAR ÁREA")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0034b812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Areas.vue
// module id = 326
// module chunks = 1